import * as Yup from "yup";

export const SignupValidation = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
  name: Yup.string()
    .min(3, "Must be greater then 3")
    .required("User Name is required"),
  password: Yup.string()
    .min(8, "Must be greater then 4")
    .required("Password is required"),
});
